import gql from 'graphql-tag'

export default gql`
	mutation createRangeLoyaltyCards(
		$ids: RangeIds,
		$fields: LoyaltyCardFields,
		$importItems: [LoyaltyCardFields]
	) {
		cashAssist {
			createRangeLoyaltyCards(ids: $ids, fields: $fields, importItems: $importItems)
		}
	}
`
